import { Button } from "./ui/button";
// import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { useDispatch, useSelector } from "react-redux";
import { signOut } from "aws-amplify/auth";
import { logoutSuccess } from "@/store/slices/authSlice";
import { PersonaNotifications } from "./PersonaNotifications";
import { LogoIcon } from "./LogoIcon";
import type { AppDispatch, RootState } from "@/store";

export function Navbar() {
  const dispatch = useDispatch<AppDispatch>();
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated
  );
  const userAttributes = useSelector(
    (state: RootState) => state.auth.userAttributes
  );

  const handleLogout = async () => {
    try {
      await signOut();
      dispatch(logoutSuccess());
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  // Determine the name to display
  const displayName =
    userAttributes?.name ||
    userAttributes?.given_name ||
    userAttributes?.email ||
    "User";

  return (
    <nav className="border-b border-gray-800 bg-gray-900/95 backdrop-blur supports-[backdrop-filter]:bg-gray-900/90 shadow-lg">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <LogoIcon size={32} className="text-primary" />
          <h1 className="text-xl font-bold bg-gradient-to-r from-amber-400 via-yellow-500 to-amber-600 bg-clip-text text-transparent">
            Taste AI Personas
          </h1>
        </div>

        <div className="flex items-center space-x-4">
          {isAuthenticated && <PersonaNotifications />}
          {isAuthenticated ? (
            <>
              <div className="flex items-center space-x-2">
                {/* <Avatar className="h-8 w-8">
                  <AvatarImage
                    src={userAttributes?.picture}
                    alt={displayName}
                  />
                  <AvatarFallback>
                    {displayName.charAt(0)}
                  </AvatarFallback>
                </Avatar> */}
                <span className="text-sm font-medium text-gray-200">
                  {displayName}
                </span>
              </div>
              <Button
                variant="outline"
                size="sm"
                onClick={handleLogout}
                className="border-gray-600 text-gray-200 bg-transparent hover:bg-gray-800 hover:text-white hover:border-gray-500"
              >
                Logout
              </Button>
            </>
          ) : (
            <Button
              variant="outline"
              size="sm"
              className="border-gray-600 text-gray-200 bg-transparent hover:bg-gray-800 hover:text-white hover:border-gray-500"
            >
              Login
            </Button>
          )}
        </div>
      </div>
    </nav>
  );
}
